import React, { useState, useRef, useEffect } from "react"
import { useProduct } from '~/contexts/ProductContext'
import { notBlank } from '~/utils/helpers'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/pdp/info_accord.module.scss"


const InfoAccord = () => {
  const { product } = useProduct()
  const { 
    csoon, is_lastc, final_sale, description, product_line, color, modelinfo
  } = product

  const [didLoad, setDidLoad] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const openRef = useRef(null)

  const check_ps = (str) => {
    const sep = str.toString()
    return !sep.includes('<p>') ? `<p>${sep}</p>` : sep

  }

  const infos = []
  const desc = description || product_line.description
  let fit_size = product.fit_size || product_line.fit_size

  const is_venice = color?.name && color.name.toLowerCase().includes('venice wash') 
  let venice_txt = !is_venice ? '' : `<p>
                      Our signature Venice Wash combines small-batch garment dyeing and natural enzyme rinsing to create 
                      subtle color variation. The result is a one-of-a-kind look with the distinctive highs-and-lows of 
                      timeworn vintage garments.
                     </p>`
  if ( notBlank(desc) ) infos.push({title: 'Description', copy: venice_txt + desc})

  let has_fit = false
  let has_fabric = false

  if (fit_size) {
    has_fit = fit_size.find(x => x.title.toLowerCase() === 'body' || x.title.toLowerCase() === 'fit')
    has_fabric = fit_size.find(x => x.title.toLowerCase() === 'fabric') || fit_size.find(x => x.title.toLowerCase() === 'material')
    if (has_fit) {
      let fit_copy = check_ps(has_fit.copy)
      if (modelinfo) {
        const mod_title = `<p class="${styles.subtitle}">Model info</p>`
        fit_copy += (mod_title + check_ps(modelinfo))
      }
      infos.push({title: 'Fit', copy: fit_copy})
    }
    if (has_fabric) {
      let fab_copy = check_ps(has_fabric.copy)
      const has_care = fit_size.find(x => x.title.toLowerCase() === 'care')
      const fab_title = `<p class="${styles.subtitle}">Care</p>`
      if (has_care) fab_copy += (fab_title + check_ps(has_care.copy))

      const has_origin = fit_size.find(x => x.title.toLowerCase() === 'origin')
      const ori_title = `<p class="${styles.subtitle}">Origin</p>`
      if (has_origin) fab_copy += (ori_title + check_ps(has_origin.copy))

      infos.push({title: has_fabric.title.toLowerCase() === 'material' ? 'Material' : 'Fabric', copy: fab_copy})
    }
  }

  if (!csoon && !is_lastc && !final_sale) {
    infos.push({
      title: 'Returns', 
      copy: `<p>We accept returns and exchanges within 365 days of purchase as long as the products are still as good 
              as new with original tags intact.</p>
             <p>Come by the store for a free on-the-spot return or exchange. If you’d rather return by mail, please 
              note the $8 deduction to cover handling costs.</p>
             <p>Due to our commitment to delivering the best experience to our customers, we are unable to accept 
              returns of shoes that show signs of wear or damage. We appreciate your understanding in this matter.</p>`
    })
  }
  

  const fix_title = (title) => {
    let new_title = title.toLowerCase().replace(':','').trim()
    return new_title === 'body' ? 'fit' : new_title
  }

  const handleClick = (index) => {
    const name = fix_title(infos[index].title)
    const is_on = index === activeTab
    const evts = {
      description: '100465018',
      fit: '100465019',
      fabric: '100465021',
      returns: '100465022'
    }
    if (!is_on) {
      window._conv_q = window._conv_q || []
      window._conv_q.push(["triggerConversion", evts[name]])
    }
    setActiveTab(is_on ? null : index)
  }

  useEffect(() => {
    if (didLoad) {
      document.querySelectorAll(`.${styles.content}`).forEach(x => x.style.height = '')
    }
    
    if (!openRef.current) return

    const copy_el = openRef.current.querySelector(`.${styles.copy}`)
    const height = Math.round(copy_el.getBoundingClientRect().height)
    openRef.current.style.height = `${height}px`
    if (!didLoad) setDidLoad(true)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab])

  return (
    <>
      {infos && infos.length > 0 && (
        <div className={styles.info_accs}>
          {infos.map( (item, index) => 
            <button 
              key={`info_${index}`} 
              id={`ar_dbtn-${index}`}
              className={[aria_btn, styles.info_acc].join(' ')}
              aria-expanded={index === activeTab ? 'true' : 'false'}
              aria-controls={`ar_detail-${index}`}
              onClick={(e) => handleClick(index)} 
              type={'button'}
            >
              <div
                className={styles.info_btn} 
              >
                <span>{fix_title(item.title)}</span>
              </div>
              <div 
                id={`ar_detail-${index}`}
                className={styles.content} 
                aria-hidden={index === activeTab ? 'false' : 'true'}
                aria-labelledby={`ar_dbtn-${index}`}
                role="region"
                ref={index === activeTab ? openRef : undefined}
              >
                <div className={styles.copy} dangerouslySetInnerHTML={{ __html: item.copy }} />
              </div>
            </button>
          )}
        </div>
      )}
    </>
  )
}

export default InfoAccord













